export const CAT_WP_CONST = {
    END_POINT: "werkplannen",

    LINK_FOLDER: "KOPPEL_FOLDER",
    SELECT_SUPERVISORS: "SELECTEREN_TOEZICHTHOUDERS",
    SELECT_DIRECTOR: "SELECTEREN_DIRECTIEVOERDER",
    SELECT_PERFORMERS: "SELECTEREN_UITVOERDERS",
    INSERT_IN_BUDGET: "PLAATS_IN_BUDGET",
    REMOVE_FROM_BUDGET: "VERWIJDER_UIT_BUDGET",
}

export const CAT_MU_CONST = {
    END_POINT: "beheereenheden",

    LINK_FOLDER: "KOPPEL_FOLDER",
}

export const CAT_JR_CONST = {
    END_POINT: "werkbronnen",

    TORK_PERFORMANS: "KOPPEL_UITVOERDER"
}
